import { ReactNode } from "react";

interface FeatureHighlightItemProps {
  icon: ReactNode;
  text: string;
}

export function FeatureHighlightItem({
  icon,
  text,
}: FeatureHighlightItemProps) {
  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-text-white">
      <div className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-bg-white/10 tw-rounded-lg tw-backdrop-blur-sm">
        {icon}
      </div>
      <span className="tw-font-bold">{text}</span>
    </div>
  );
}
